<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
            Well Production Status
        </div>

        <form [formGroup]="searchForm">
            <app-table-filter [searchForm]="searchForm" (searchTriggered)="handleSearch($event)"
                class="text-primary"></app-table-filter>

            <div class="grid grid-cols-1 sm:grid-cols-3 ">
                <div class="flex justify-start col-span-2">
                    <div class="w-19 ml-2">
                        <mat-form-field class="w-full no-bottom-gap mb-2">
                            <mat-select formControlName="PageSize">
                                <mat-option [value]="10"> 10 </mat-option>
                                <mat-option [value]="20"> 20 </mat-option>
                                <mat-option [value]="50"> 50 </mat-option>
                                <mat-option [value]="100"> 100 </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                        (apply)="applySort($event)">
                    </app-sort-menu>

                    <button class="btn btn-outline btn-default dt-download mx-2" matTooltip="Download Records"
                        (click)="exportToExcel()">
                        <mat-icon class="text-primary hover:text-white"
                            svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                    </button>
                </div>
                <div class="flex justify-end">
                    <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                        Search
                    </button>
                    <button class="btn btn-outline btn-default" (click)="reset()">
                        Reset
                    </button>
                    <button class="btn btn-outline btn-default mx-2 hover:text-white" matTooltip="Refresh Table"
                        (click)="setPage({ offset: dt.page.offset})">
                        <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                    </button>
                </div>

                <div class="flex justify-start col-span-2">
                    <span class="self-center font-medium text-gray-400 italic text-md p-2 pb-1">
                        Sorting by {{ sortInfo }}
                    </span>
                </div>

                <div class="flex justify-end">
                    <span class="self-center font-medium text-primary text-md p-2 pb-1">
                        {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </span>
                </div>
            </div>
        </form>

        <div class="p-2">
            <div class="grid overflow-x-auto">
                <!-- Header -->
                <div class="table-well-production-status-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                    matSort matSortDisableClear>
                    <div class="border py-8 text-center">
                        No
                    </div>

                    <div [mat-sort-header]="'fieldLongName'"
                        class="flex justify-center border py-4 my-custom-sort-header">
                        Field
                    </div>

                    <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                        Platform
                    </div>

                    <div [mat-sort-header]="'wellLongName'" class="flex justify-center border text-center py-4">
                        Well
                    </div>

                    <div [mat-sort-header]="'stringShortName'" class="flex justify-center border text-center py-4">
                        Well String
                    </div>

                    <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                        String Indicator
                    </div>

                    <div [mat-sort-header]="'wellFlowCategory'" class="flex border justify-center py-4">
                        Flow Category
                    </div>

                    <div [mat-sort-header]="'wellStringType'" class="flex border justify-center py-4">
                        Well Type
                    </div>

                    <div [mat-sort-header]="'lastUpdatedBy'" class="flex border justify-center py-4">
                        Last Updated By
                    </div>

                    <div [mat-sort-header]="'lastUpdatedDate'" class="flex border justify-center py-4">
                        Last Updated Date
                    </div>

                    <div [mat-sort-header]="'wellProductionStatus'" class="flex justify-center border py-4 px-4">
                        Current Production Status
                    </div>

                    <div class="block border text-center py-8">
                        Action
                    </div>
                </div>
                <!-- Rows -->
                <ng-container *ngIf="dt.rows.length; else noRecords">
                    <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                        <div class="table-well-production-status-record-grid grid items-center border-b"
                            [ngClass]="{'bg-primary-100': i % 2 }">

                            <!-- No -->
                            <div class="py-4 text-center">
                                {{startingIndex + i + 1}}.
                            </div>

                            <!-- Field Long Name -->
                            <div class="flex truncate justify-center">
                                {{ row.fieldLongName }}
                            </div>

                            <!-- Platform Long Name  -->
                            <div class="flex justify-center">
                                {{ row.platformLongName }}
                            </div>

                            <!-- Well Long Name  -->
                            <div class="flex justify-center">
                                {{ row.wellLongName }}
                            </div>

                            <!-- String Short Name  -->
                            <div class="text-center">
                                {{ row.stringShortName }}
                            </div>

                            <!-- String Indicator -->
                            <div class="block text-center">
                                {{ row.stringIndicatorShortName }}
                            </div>

                            <!-- Flow Category -->
                            <div class="block text-center">
                                {{ row.wellFlowCategory || '-' }}
                            </div>

                            <!-- Well Type -->
                            <div class="block text-center">
                                {{ row.wellStringType }}
                            </div>

                            <!-- Activity Date -->
                            <div class="block text-center">
                                {{ row.lastUpdatedBy }}
                            </div>

                            <!-- THP -->
                            <div class="block text-center">
                                {{ handleFormatDate(row.lastUpdatedDate, false) }}
                            </div>

                            <!-- Annulus Pressure Reading (PCP) -->
                            <div class="block text-center">
                                {{ row.prodStatus }}
                            </div>

                            <!-- Action button -->
                            <div class="flex justify-center">
                                <button class="btn btn-remove-bg " (click)="openHistoricalModal(row)">
                                    <mat-icon class="text-primary" matTooltip="View Historical Records"
                                        [svgIcon]="'heroicons_outline:document-chart-bar'"></mat-icon>
                                </button>

                                <button class="btn btn-remove-bg" (click)="editProdCategoryModal(row)" [disabled]="!hasWellProdStatusEditRoles()">
                                    <mat-icon class="text-primary" matTooltip="Edit"
                                        [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #noRecords>
                    <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                        There are no records registered!
                    </div>
                </ng-template>
            </div>

            <div
                class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
                <div class="content-center px-3">
                    {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </div>

                        <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                            [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                            [hidePageSize]="true" [showFirstLastButtons]="true">
                        </mat-paginator>
                </div>
            </div>
        </div>
    </div>